import React, { Component } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import { Link, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import config from './config';
import Alert from './components/Alert';

const maxTitleChars = 50;
const defaultImage = "data:image/png;base64,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";

export default withOktaAuth(class OrganizationalChart extends Component {

    constructor() {
        super();
        this.state = {
            isAuthenticated: false,
            userinfo: null,
            ready: false,
            results: null,
            failed: false,
            isEditMode: false,
            isEditable: false,
            isCurrentUser: false,
            userDomain: '',
            alert: null,
            managers: [],
            selectedManagerIdx: 0
        };
        this.accessToken = '';
    }

    async componentDidMount() {
        this.accessToken = this.props.authState.accessToken.accessToken;
        let userprofile = await this.getUserProfile();

        if (!userprofile) {
            this.setState({ ready: true, isAuthenticated: this.props.authState?.isAuthenticated });
            return;
        }

        let manager = {};
        // syncidmanager est prioritaire sur manager s'il est rempli
        const managerField = userprofile.syncidmanager || userprofile.manager || userprofile.C_groupIdentifier;
        manager = await this.getManager(managerField);
        if (!manager || !Array.isArray(manager.managers) || manager.managers.length === 0) {
            manager = await this.getManager(userprofile.C_distinguishedName);
        }
        
        // S'assurer qu'on a des managers avant de les définir
        const managers = manager && manager.managers ? manager.managers : [];
        const selectedManagerIdx = manager && manager.selectedManagerIdx ? manager.selectedManagerIdx : 0;
        
        this.setState({ 
            ready: true, 
            userProfile: userprofile, 
            managers: managers, 
            selectedManagerIdx: selectedManagerIdx, 
            isAuthenticated: this.props.authState?.isAuthenticated 
        }, () => {
            this.getPhoto();
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps?.authState && this.props?.authState && prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated) {
            this.setState({ isAuthenticated: this.props.authState?.isAuthenticated });
        }
    }

    showAlert(type, title, message) {
        this.setState({
            alert: { type, title, message }
        });
        // Auto-hide alert after 5 seconds
        setTimeout(() => {
            this.setState({ alert: null });
        }, 5000);
    }

    hideAlert() {
        this.setState({ alert: null });
    }

    async getUserProfile() {
        try {
            let searchstring = window.location.search.replace("?", "");
            const response = await fetch(config.env.resourceServer.getOktaProfileUrl + "?userId=" + (searchstring ? searchstring : this.state.userinfo?.preferred_username), {
                headers: {
                    Authorization: `Bearer ${this.accessToken}`
                },
            });

            if (response.status !== 200) {
                return;
            }

            const data = await response.json();
            return data;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async getManager(selectedDN) {
        try {
            let manager = {
                manager: selectedDN
            };
            let managers = [];
            let response = {};

            while (manager.manager) {
                try {
                    let escapedManager = manager.manager.replace("\\", "\\\\");
                    escapedManager = encodeURI(escapedManager);
                    response = await fetch(`${config.env.resourceServer.getManager}?manager=${escapedManager}`, {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`
                        },
                    });

                    if (response.status !== 200) {
                        manager = {};
                        return;
                    }
                    manager = await response.json();
                    managers.splice(0, 0, manager);

                } catch (error) {
                    manager = {};
                    console.log(error);
                }
            }
            return { managers: managers, selectedManagerIdx: managers.length - 1 }
        } catch (err) {
            console.log(err);
            console.log('err');
        }
        return null;
    }

    async getPhoto() {
        try {
            if (!this.state.managers || this.state.managers.length === 0) {
                return;
            }
            
            var size = "240x240";
            this.state.managers.forEach((manager, i) => {
                try {
                    fetch(`${config.env.apiBaseUrl}/get-user-photo?userId=${manager.login}&size=${size}`, {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`
                        },
                    }).then(async response => {
                        if (response.status !== 200) {
                            manager.photo = defaultImage;
                            return;
                        }

                        let data = await response.json();
                        manager.photo = data.image ? data.image : defaultImage;
                        this.setState({ managers: this.state.managers }, () => {
                            if (this.state.selectedManagerIdx !== i) {
                                return;
                            }
                            manager.collaborators.forEach((collaborator) => {
                                fetch(`${config.env.apiBaseUrl}/get-user-photo?userId=${collaborator.login}&size=${size}`, {
                                    headers: {
                                        Authorization: `Bearer ${this.accessToken}`
                                    },
                                }).then(async response => {
                                    if (response.status !== 200) {
                                        collaborator.photo = defaultImage;
                                        return;
                                    }

                                    let data = await response.json();
                                    collaborator.photo = data.image;
                                    this.setState({ managers: this.state.managers });
                                });
                            });
                        });
                    });
                } catch (error) {
                    console.error(error);
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    async changeLevel(direction, idx) {
        if (this.changingLvl) {
            return;
        }
        
        if (!this.state.managers || this.state.managers.length === 0) {
            return;
        }
        
        this.changingLvl = true;
        if (direction === 'top') {
            let managers = this.state.managers.slice(0, idx + 1);
            this.setState({ managers: managers, selectedManagerIdx: idx }, () => {
                this.getPhoto();
            });
        } else {
            try {
                var managers = this.state.managers;
                var manager = null;

                if (!this.state.managers[this.state.selectedManagerIdx] || 
                    !this.state.managers[this.state.selectedManagerIdx].collaborators ||
                    !this.state.managers[this.state.selectedManagerIdx].collaborators[idx]) {
                    this.changingLvl = false;
                    return;
                }

                var managerGID = this.state.managers[this.state.selectedManagerIdx].collaborators[idx].C_groupIdentifier;
                var response = await fetch(`${config.env.resourceServer.getManager}?manager=${managerGID}`, {
                    headers: {
                        Authorization: `Bearer ${this.accessToken}`
                    },
                });

                if (response.status !== 200) {
                    manager = null;
                }

                manager = await response.json();

                if (!manager) {
                    let escapedManager = this.state.managers[this.state.selectedManagerIdx].collaborators[idx].C_distinguishedName.replace("\\", "\\\\");
                    escapedManager = encodeURI(escapedManager);
                    response = await fetch(`${config.env.resourceServer.getManager}?manager=${escapedManager}`, {
                        headers: {
                            Authorization: `Bearer ${this.accessToken}`
                        },
                    });

                    if (response.status !== 200) {
                        return;
                    }

                    manager = await response.json();
                }

                managers.push(manager);

                this.setState({ managers: managers, selectedManagerIdx: this.state.selectedManagerIdx + 1 }, () => {
                    this.getPhoto();
                });
            } catch (error) {
                console.log(error);
            }
        }
        this.changingLvl = false;
    }

    render() {
        return (
            <div className="orgchart-container">
                {/* Alert Display */}
                {this.state.alert && (
                    <div className="alert-container">
                        <Alert
                            type={this.state.alert.type}
                            title={this.state.alert.title}
                            message={this.state.alert.message}
                            onClose={() => this.hideAlert()}
                        />
                    </div>
                )}

                {!this.state.ready && (
                    <div className="page-loading">
                        <div className="loading-spinner"></div>
                        <p className="loading-text"><FormattedMessage id="orgchart.loading" defaultMessage="Loading organization chart..." /></p>
                    </div>
                )}

                {this.state.ready && !this.state.failed && this.state.isAuthenticated && (
                    <div>
                        {/* Hero Section */}
                        <section className="hero-section bg-light page-inner">
                            <div className="overlay engiegradient-background"></div>
                            <div className="hero-banner-wrapper">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8 breadcrumb-col">
                                            <div className="page-title no-bottom-space">
                                                <nav className="breadcrumb-wrapper compact">
                                                    <div className="breadcrumb-modern compact breadcrumb-flex-center">
                                                        <Link to="/" className="breadcrumb-link breadcrumb-item"><FormattedMessage id="navbar.home" defaultMessage="Home" /></Link>
                                                        <span className="breadcrumb-separator">/</span>
                                                        <span className="breadcrumb-item breadcrumb-current"><FormattedMessage id="orgchart.title" defaultMessage="Organization Chart" /></span>
                                                    </div>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Organization Chart */}
                        <section className="orgchart-section">
                            <div className="container">
                                {/* Management Hierarchy */}
                                <div className="orgchart-hierarchy">
                                    {this.state.managers && this.state.managers.map((manager, i) => (
                                        <div key={i} className="orgchart-level">
                                            <div className="orgchart-manager-container">
                                                <div className="orgchart-card manager-card" onClick={() => this.changeLevel('top', i)}>
                                                    <div className="orgchart-card-header">
                                                        <Link to={`/profile?userId=${manager.login}`} className="profile-link">
                                                            <i className="fa-solid fa-user" aria-hidden="true"></i>
                                                        </Link>
                                                    </div>
                                                    <div className="orgchart-card-body">
                                                        <div className="orgchart-avatar">
                                                            <img
                                                                src={manager.photo || "img/default_profile_photo.png"}
                                                                alt={`${manager.firstName} ${manager.lastName}`}
                                                                className="avatar-image"
                                                            />
                                                        </div>
                                                        <div className="orgchart-info">
                                                            <h3 className="person-name">{manager.firstName} {manager.lastName}</h3>
                                                            <p className="person-title">{manager.customTitle || manager.title}</p>
                                                            <p className="person-email">{manager.email}</p>
                                                        </div>
                                                    </div>
                                                    <div className="orgchart-card-actions">
                                                        <FormattedMessage id="orgchart.sendEmail" defaultMessage="Send Email">
                                                            {(message) => (
                                                                <button
                                                                    className="btn-icon"
                                                                    title={message}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        window.open(`mailto:${manager.email}`, '_blank');
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-envelope"></i>
                                                                </button>
                                                            )}
                                                        </FormattedMessage>
                                                        <FormattedMessage id="orgchart.teamsChat" defaultMessage="Teams Chat">
                                                            {(message) => (
                                                                <button
                                                                    className="btn-icon"
                                                                    title={message}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        window.open(`https://teams.microsoft.com/l/chat/0/0?users=${manager.email}`, '_blank');
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-comments"></i>
                                                                </button>
                                                            )}
                                                        </FormattedMessage>
                                                    </div>
                                                </div>

                                                {/* Connection Line */}
                                                {manager.collaborators && manager.collaborators.length > 0 && (
                                                    <div className="orgchart-connector">
                                                        <div className="connector-line vertical"></div>
                                                        <div className="connector-line horizontal"></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Collaborators */}
                                {this.state.managers && this.state.managers.length > 0 &&
                                    this.state.managers[this.state.selectedManagerIdx] &&
                                    this.state.managers[this.state.selectedManagerIdx].collaborators &&
                                    this.state.managers[this.state.selectedManagerIdx].collaborators.length > 0 && (
                                        <div className="orgchart-collaborators">
                                            <div className="collaborators-grid">
                                                {this.state.managers[this.state.selectedManagerIdx].collaborators.map((collaborator, j) => (
                                                    <div key={j} className="orgchart-card collaborator-card" onClick={() => this.changeLevel('bottom', j)}>
                                                        <div className="orgchart-card-header">
                                                            <Link to={`/profile?userId=${collaborator.login}`} className="profile-link">
                                                                <i className="fa-solid fa-user" aria-hidden="true"></i>
                                                            </Link>
                                                        </div>
                                                        <div className="orgchart-card-body">
                                                            <div className="orgchart-avatar">
                                                                <img
                                                                    src={collaborator.photo || "img/default_profile_photo.png"}
                                                                    alt={`${collaborator.firstName} ${collaborator.lastName}`}
                                                                    className="avatar-image"
                                                                />
                                                            </div>
                                                            <div className="orgchart-info">
                                                                <h4 className="person-name">{collaborator.firstName} {collaborator.lastName}</h4>
                                                                <p className="person-title">{collaborator.customTitle || collaborator.title}</p>
                                                                <p className="person-email">{collaborator.email}</p>
                                                            </div>
                                                        </div>
                                                        <div className="orgchart-card-actions">
                                                            <FormattedMessage id="orgchart.sendEmail" defaultMessage="Send Email">
                                                                {(message) => (
                                                                    <button
                                                                        className="btn-icon"
                                                                        title={message}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            window.open(`mailto:${collaborator.email}`, '_blank');
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-envelope"></i>
                                                                    </button>
                                                                )}
                                                            </FormattedMessage>
                                                            <FormattedMessage id="orgchart.teamsChat" defaultMessage="Teams Chat">
                                                                {(message) => (
                                                                    <button
                                                                        className="btn-icon"
                                                                        title={message}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            window.open(`https://teams.microsoft.com/l/chat/0/0?users=${collaborator.email}`, '_blank');
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-comments"></i>
                                                                    </button>
                                                                )}
                                                            </FormattedMessage>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                {/* Navigation Help */}
                                <div className="orgchart-help">
                                    <div className="help-card">
                                        <h4><FormattedMessage id="orgchart.navigationTips" defaultMessage="Navigation Tips" /></h4>
                                        <ul>
                                            <li><i className="fa-solid fa-mouse-pointer"></i> <FormattedMessage id="orgchart.clickManagerCards" defaultMessage="Click on manager cards to navigate up the hierarchy" /></li>
                                            <li><i className="fa-solid fa-users"></i> <FormattedMessage id="orgchart.clickTeamCards" defaultMessage="Click on team member cards to explore their teams" /></li>
                                            <li><i className="fa-solid fa-user"></i> <FormattedMessage id="orgchart.clickProfileIcons" defaultMessage="Click profile icons to view detailed profiles" /></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                )}
            </div>
        )
    }
});
